import { CtaData } from "#app/types/schema.ts";
import { SectionDefaultProps } from "#app/types/type.ts";
import { stegaClean } from "@sanity/client/stega";
import { GDRLogo } from "./gdr-logo";
import { cn } from "#app/utils/misc.tsx";
import SanityLink from "./sanity-link";
import { Heading } from "./text";


type CtaSectionProps = SectionDefaultProps & {
    data: CtaData;
};

const ctaColorMap = {
    default: 'bg-background text-foreground',
    muted: 'bg-muted text-foreground',
    primary: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground',
    accent: 'bg-accent text-accent-foreground',
}

const logoColorMap = {
    default: 'text-muted',
    muted: 'text-background',
    primary: 'text-muted-foreground',
    accent: 'text-muted-accent',
    secondary: 'text-muted-foreground',
}

export default function CtaSection({ data, encodeDataAttribute }: CtaSectionProps) {
    const ctaData = stegaClean(data);
    const { heading, headingLevel, tagline, textAlign, backgroundStyle, layoutWidth, buttonGroup } = ctaData;
	return (
		<div className="container">
			<div className={cn(
                "mx-auto relative isolate overflow-hidden rounded-md px-6 py-16 lg:flex lg:items-center lg:justify-between lg:px-8",
                ctaColorMap[backgroundStyle],
            )}>
				<GDRLogo className={cn('absolute bottom-0 right-0 -z-10', logoColorMap[backgroundStyle])} />
				{heading && (
                <Heading as={headingLevel} className="max-w-2xl text-5xl font-semibold tracking-tight sm:text-6xl">
					{heading}
				</Heading>)}
				<div className="mt-10 flex flex-col justify-center gap-6 lg:mt-0 lg:shrink-0">
                    {buttonGroup?.map((button, index) => (
                        <div key={index}>
                            <SanityLink
                                link={button}
                                encodeDataAttribute={encodeDataAttribute}
                            >
                                {button.text}
                            </SanityLink>
                        </div>
                    ))}
				</div>
			</div>
		</div>
	)
}